import { render, staticRenderFns } from "./ShapeLinksCreate.vue?vue&type=template&id=cb948eba"
import script from "./ShapeLinksCreate.vue?vue&type=script&lang=js"
export * from "./ShapeLinksCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports